import React, { Component, createRef } from "react";
// // Editable
// import { BootstrapTable,TableHeaderColumn } from "react-bootstrap-table";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import validate from "../../common/validation";
import BarCode from "react-barcode";

import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { categoriTypes } from "../StaticData.js";
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addDataEntryStock,
  getUserByRoleId,
  getUserApi,
  updateDataEntryStock,
  getShapes,
} from "../../api";
import { withTranslation } from "react-i18next";
import { createPortal } from "react-dom";
import QrcodeGenerator from "./QrcodeGenerator";
import ShowDiffenence from "components/Common/ShowDiffenence";

class DataEntryAddStockInword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      qrValue: {},
      editRowIndex: -1,
      isSubmit: false,
      isCreate: false,
      isExits:false,
      createStockData:[],
      pieces:
        props?.location?.query && props.location.query.isEdit == 1
          ? props.location.query.data.pieces
          : props.location.query.data.jangad.pieces,
      props: props?.location?.query
        ? props.location.query
        : {
            isEdit: 1,
            data: null,
          },
      graderList: [],
      notEditableRows:
        props.location.query.isEdit == 1
          ? (() => {
              let array = [];
              for (let i = 0; i < props.location.query.data.pieces; i++) {
                array.push(i + 1);
              }
              return array;
            })()
          : props?.location?.query?.data?.stockDataEntryInWards.map(x => x.id),
      stockList:
        props.location.query.isEdit == 1
          ? (() => {
              let array = [];
              for (let i = 0; i < props.location.query.data.pieces; i++) {
                array.push({
                  id: i + 1,
                  srNo: i + 1,
                  weight: 0,
                  weightType: "CT",
                  pieces: 1,
                  shapeId: "",
                  remarks: "",
                  nextRemarks: "",
                });
              }
              return array;
            })()
          : props?.location?.query.data.stockDataEntryInWards,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  validateTable() {
    for (let i = 0; i < this.state.stockList.length; i++) {
      let e = this.state.stockList[i];
      if ((e.shapeId == "" && e.weight > 0) || (e.shapeId != "" && e.weight == 0)) {
        return false;
      }
    }
    return true;
  }

  async componentDidMount() {
    $('#gname').on('change', function() {
      if (this.value) {
        $("#guseriderror").hide();
      }
    });
    document.getElementsByTagName("body")[0].onafterprint = () => {
      this.setState({
        qrValue: {},
      });
    };
    const grader = await getUserApi({
      factoryId:
        this.state.props.isEdit == 1
          ? this.state.props.data.factory.id
          : this.state.props.data.jangad.factory.id,
      roleId: "ROLE0000002",
    });
    if (grader && grader.data) {
      this.setState({
        graderList: grader.data.users,
      });
    }
    const shape = await getShapes();
    if (shape && shape.data) {
      this.setState({
        shapesList: [
          { label: "NONE", value: "" },
          ...shape.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }


    // if(this.state.props.isEdit == 2){
    //   for(var i = 1; i <= this.state.stockList.length; i++) {
    //     $(`.${i}savebtn1`).hide();
    //     $(`.${i}savebtn2`).hide();
    //   }
    // }
  }

  deleteRow(rowIndex) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: this.state.stockList,
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
  }

  addRow() {
    const existingSrnos = this.state.stockList.map(item => item.srNo);
    const maxSrNo = Math.max(...existingSrnos);
    const newSrNo = maxSrNo !== -Infinity ? maxSrNo + 1 : 1;
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: this.state.stockList.length + 1,
          srNo:newSrNo,
          status:false,
          shapeId: "",
          categoryId: 1,
          weight: 0,
          weightType: "CT",
          pieces: 1,
          remarks: "",
          nextRemarks: "",
        },
      ],
      notEditableRows: [
        ...this.state.notEditableRows,
        this.state.stockList.length + 1,
      ],
    });
    
  }

  saveStockInfo = async values =>{
    const weight = values.weight;
    const shapeId = values.shapeId;

    if (this.state.stockList.filter(x => x.weight > 0 && x.pieces > 0).length) {

      if((weight == 0 && shapeId == "") || shapeId == "" || weight == 0){
        this.setState({
          isSubmit:true,
        });
      }else {
        //  const stockData = this.state.stockList.filter(stockInfo=>stockInfo.srNo <= values.srNo);
         const stockData = this.state.stockList;
    
            // for(var i = 1; i <= values.srNo; i++) {
            //   $(`.${i}savebtn1`).hide();
            //   $(`.${i}savebtn2`).hide();
              
            // }
        
         let temp = {};
         temp.id = this.state.props?.data?.id;
         temp.graderStatus = "P";
         temp.jangadId = this.state.props?.data?.jangadId;
         temp.graderUserId = this.state.props?.data?.graderUserId;
         temp.nextRemarks = this.state.props?.data?.nextRemarks;
         temp.stockDataEntryInWards = stockData
           .filter(x => x.weight > 0 && x.pieces > 0)
           .map(x => {
             return {
               ...x,
               jangadId: this.state.props?.data?.jangadId,
               mainJangadId: this.state.props.data.jangadId,
               dataEntryStockId: this.state.props?.data?.id,
             };
           });  
           const data = await updateDataEntryStock(temp);
          
           
       }
    }
  }

  saveStockInfo2 = async values =>{
    const weight = values.weight;
    const shapeId = values.shapeId;
    var graderNameId = document.getElementById('gname');
    const invalidGraderName = document.getElementById("guserid");

    if(graderNameId?.value !== "" && ((weight !== 0 && shapeId !== "") || shapeId !== "" || weight !== 0)){
      console.log('grader value found');
      $("#guseriderror").hide();

      
      if(this.state.isExits !==true){
        
        // const stockData = this.state.stockList.filter(stockInfo=>stockInfo.srNo <= values.srNo);
        const stockData = this.state.stockList;
      // for(var i = 1; i <= values.srNo; i++) {
      //         $(`#${i}savebtn3`).hide();
      //         $(`.${i}savebtn4`).hide();
      //       }
            
         $(`#hidesubmit`).hide();
        let temp = {};
        temp.jangadId = this.state.props.data.id;
        temp.mainJangadId = this.state.props?.data?.mainJangadId;
        temp.remarks = values.remarks;
        temp.nextRemarks = values.nextRemarks;
        temp.graderUserId = graderNameId.value;
        temp.stockDataEntryInWards = stockData
          .filter(x => x.weight > 0 && x.pieces > 0)
          .map(x => {
            return {
              ...x,
              jangadId: this.state.props.data.id,
              mainJangadId: this.state.props?.data?.mainJangadId,
            };
          });
          
        const data = await addDataEntryStock(temp);
        this.setState({
          isExits:true,
          createStockData:data
        })
        console.log('data',data);

      }else {
        // const stockData = this.state.stockList.filter(stockInfo=>stockInfo.srNo <= values.srNo);
        const stockData = this.state.stockList;
        console.log('up inside data',this.state.createStockData);
        console.log('dataEntryStockId',this.state.createStockData.data.stockDataEntryInWards[0].dataEntryStockId);
    
         let temp = {};
         temp.id = this.state.createStockData.data.stockDataEntryInWards[0].dataEntryStockId;
         temp.graderStatus = "P";
         temp.jangadId = this.state.createStockData.data.jangadId;
         temp.graderUserId = this.state.createStockData.data.graderUserId;
         temp.nextRemarks = this.state.props?.data?.nextRemarks;
         temp.stockDataEntryInWards = stockData
           .filter(x => x.weight > 0 && x.pieces > 0)
           .map(x => {
             return {
               ...x,
               jangadId: this.state.createStockData.data.jangadId,
               mainJangadId: this.state.createStockData.data.mainJangadId,
               dataEntryStockId: this.state.createStockData.data.stockDataEntryInWards[0].dataEntryStockId,
             };
           });  

           const data1 = await updateDataEntryStock(temp);
        console.log('update data',data1);
      }
      
      } 
    else {
      console.log('grader not value found');
      if (!graderNameId?.value) {
        $("#guseriderror").show();
      }
      this.setState({
        isSubmit:true,
      });
      if(invalidGraderName){
        invalidGraderName.innerText = 'this value is required'
      }  
    }

   
  }

  handleSubmit = async values => {
    if (this.state.stockList.filter(x => x.weight > 0 && x.pieces > 0).length) {
      if (this.state.props.isEdit == 1) {
        let temp = {};
        temp.jangadId = this.state.props.data.id;
        temp.mainJangadId = values.id;
        temp.remarks = values.remarks;
        temp.nextRemarks = values.nextRemarks;
        temp.graderUserId = values.graderUserId;
        temp.stockDataEntryInWards = this.state.stockList
          .filter(x => x.weight > 0 && x.pieces > 0)
          .map(x => {
            return {
              ...x,
              jangadId: this.state.props.data.id,
              mainJangadId: values.id,
            };
          });
        const data = await addDataEntryStock(temp);
        if (data?.success == true) {
          this.setState({
            isCreate: true,
          });
        }
        // this.props.history.goBack();
      } else {
        let temp = {};
        temp.id = this.state.props.data.id;
        temp.graderStatus = "P";
        temp.jangadId = values.jangadId;
        temp.graderUserId = values.graderUserId;
        temp.nextRemarks = values.nextRemarks;
        temp.stockDataEntryInWards = this.state.stockList
          .filter(x => x.weight > 0 && x.pieces > 0)
          .map(x => {
            return {
              ...x,
              jangadId: this.state.props.data.jangadId,
              mainJangadId: values.id,
              dataEntryStockId: this.state.props.data.id,
            };
          });
        const data = await updateDataEntryStock(temp);
        // this.props.history.goBack();
      }
    }
  };

  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    const defaultSorted = [
      {
        dataField: "srNo",
        order: "asc",
      },
    ];
    document.title = "data entry person";
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("id")}`,
        footer: "",
        sort: true,
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        sort: true,
        editable: false,
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: (columnData, cell) => {

           return columnData.reduce((acc, item) => acc + item, 0).toFixed(2)
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "pieces", newValue, row, column),
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: (columnData, cell) => {
          return columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT"
        },
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =  cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color};
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "weight", newValue, row, column),
      },

      {
        dataField: "shapeId",
        text: `${this.props.t("Shapes")}`,
        editable: true,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.shapesList,
        },
        formatter: (cell, row) => {
          console.log(typeof row.id);
          if (cell == "") {
            return "NONE";
          } else if (
            parseInt(cell) > 0 &&
            this.state.props.isEdit != 1 &&
            row.id.toString().includes("DIAMOND") &&
            cell == row.shape.id
          ) {
            return row.shape.name;
          } else {
            return this.state.shapesList?.filter(x => x.value == cell)[0]
              ?.label;
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
            const color =  cell == "" && this.state.isSubmit == true ? "red" : "#495057";
      
          return { color};
        },
      },
      {
        dataField: "remarks",
        text: `${this.props.t("Self Internal Remarks")}`,
        footer: "",
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person Instruction")}`,
        footer: "",
      },
      this.state.props.data.graderStatus == "P" || this.state.props.data.dataEntryStatus== "P"
        ? {
            dataField: "edit",
            text: `${this.props.t("Action")}`,
            footer: "",
            editable: true,
            editorRenderer: (
              editorProps,
              value,
              row,
              column,
              rowIndex,
              columnIndex
            ) => {
              return (
                <div className="btn-group">
                  {/* {!this.state.notEditableRows.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows: [...this.state.notEditableRows, row.id],
                    });
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    if (
                      this.state.notEditableRows.length ===
                      this.state.stockList.length
                    )
                      this.setState({
                        notEditableRows: this.state.notEditableRows.filter(
                          x => x != row.id
                        ),
                      });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
              <button
                type="button"
                className="bg-transparent border-0 ms-3"
                onClick={() => this.deleteRow(rowIndex)}
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button> */}
                  {this.state.props.isEdit == 2 ? (
                    <>
                    <button
                      type="button"
                      className="border-0 p-2 btn-active raised-btn rounded ms-3"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={() =>
                        this.setState({ qrValue: row }, () =>
                          console.log(this.state)
                        )
                      }
                    >
                      {" "}
                      Print{" "}
                    </button>

                    <button
                    type="button"
                    className={`border-0 p-2 btn-active raised-btn rounded ms-3 ${row.srNo}savebtn1`}
                    onClick={() =>
                      this.saveStockInfo(row)
                    }
                  >
                    {" "}
                   save{" "}
                  </button>
                    </>
                  ) : (
                    <></>
                  )}

                  {this.state.props.isEdit == 1 ?(
                    <button
                    type="button"
                    id={`${row.srNo}savebtn3`}
                    className={`border-0 p-2 btn-active raised-btn rounded ms-3`}
                    onClick={() =>
                      this.saveStockInfo2(row)
                    }
                  >
                    {" "}
                   save{" "}
                  </button>
                  ):(
                    <></>
                  )}

                 
                </div>
              );
            },
            formatter: (cell, row,rowIndex) => (
             
              <div className="btn-group d-flex align-items-center">
                <div
                  id={`orignal-barcode-${row.srNo}`}
                  className="invisible d-none"
                >
                  <BarCode
                    value={
                      this.state.props.data.mainJangad.name +
                      "&" +
                      row.srNo +
                      "$"
                    }
                    fontSize={15}
                    width={1.5}
                    height={15}
                  />
                </div>
                {/* {!this.state.notEditableRows.includes(row.id) ? (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  this.setState({
                    notEditableRows: [...this.state.notEditableRows, row.id],
                  });
                }}
              >
                <img src="images/dashboard-images/print.svg"></img>
              </span>
            ) : (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  if (
                    this.state.notEditableRows.length ===
                    this.state.stockList.length
                  )
                    this.setState({
                      notEditableRows: this.state.notEditableRows.filter(
                        x => x != row.id
                      ),
                    });
                }}
              >
                <img src="images/dashboard-images/edit.svg"></img>
              </span>
            )}
            <button
              type="button"
              className="bg-transparent border-0 ms-3"
              onClick={() => this.deleteRow(rowIndex)}
            >
              <img src="images/dashboard-images/deleteRow.svg"></img>
            </button> */}
                {this.state.props.isEdit == 2 ? (
                <>
                  <button
                    type="button"
                    className="border-0 p-2 btn-active raised-btn rounded ms-3"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={() => this.setState({ qrValue: row })}
                  >
                  Print
                  </button>
                  <button
                      type="button"
                      className={`border-0 p-2 btn-active raised-btn rounded ms-3 ${row.srNo}savebtn2`}
                      onClick={() =>
                        this.saveStockInfo(row)
                      }
                    >
                      {" "}
                     save{" "}
                    </button>
                  
                  


                </>
                ) : (
                  <></>
                )}
                {this.state.props.isEdit == 1 ?(
                  <button
                  type="button"
                  className={`border-0 p-2 btn-active raised-btn rounded ms-3 ${row.srNo}savebtn4`}
                  onClick={() =>
                    this.saveStockInfo2(row)
                  }
                >
                  {" "}
                 save{" "}
                </button>
                ):(
                  <></>
                )}
              </div>
            ),
          }
        : {
            dataField: "ar",
            text: `${this.props.t("Status")}`,
            footer: "",
            editable: true,
            formatter: (cell, row, rowIndex) => (
              <div className="btn-group d-flex align-items-center">
                {cell ? (
                  <button className="btn-success-green border-0 py-2 px-3 rounded">
                    Accept
                  </button>
                ) : (
                  <button className="btn-danger-red border-0 py-2 px-3 rounded">
                    Reject
                  </button>
                )}
              </div>
            ),
          },
          
    ];
    this.state.props.isEdit == 1 ? this.columns1 : this.columns1;
    document.title = "data-entry flow";
    return (
      <React.Fragment>
        <div>
          <div className="d-none p-0">
            {this.state.qrValue.name && (
              <>
                <iframe
                  allowFullScreen="true"
                  sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
                  allow=""
                  srcDoc={`<table className="" width="100%">

                      <tr>
                        <td colspan="3"><b>S.No:</b> ${
                          this.state.props.data.mainJangad.name +
                          "-" +
                          this.state.qrValue?.srNo
                        }</td>
                        <td class="padding" colspan="2"><b>P: </b> ${
                          this.state.props.data.mainJangad?.party?.partyCode
                        }</td>
                      </tr>
                      <tr>
                      <th>T Weight:</th>
                        <td>${
                          this.state.stockList
                            .filter(x => x.ar == true || x.ar == "true")
                            .reduce((accum, curr) => {
                              return (accum += curr.weight);
                            }, 0)
                            .toFixed(2) + " C"
                        }</td>

                        <th class="padding">T Pcs:</th>
                        <td>${
                          this.state.stockList.filter(
                            x => x.ar == true || x.ar == "true"
                          ).length
                        }</td>

                      </tr>
                      <tr>
                      <th>Weight:</th>
                        <td>${this.state.qrValue?.weight.toFixed(2) + " C"}</td>

                        <th class="padding">Shape:</th>
                        <td>${this.state.qrValue?.shape.name}</td>

                      </tr>
                      <tr>
                      <td colspan="4" style={text-align: right}>
                        ${
                          document.getElementById(
                            "orignal-barcode-" + this.state.qrValue.srNo
                          )?.innerHTML
                        }</td>
                      </tr>

                    </table> <script>window.print()</script>
                    <style>
                    th, td {
                         font-size: 15px;
                         padding: 0px;
                    }
                    .padding{
                      padding-left: 15px;
                    }
                    th{
                      text-align:left;
                    }
                    table{
                    }
                    @media print {
                      .no-print,
                      .no-print * {
                          display: none !important;
                      }import { values } from 'lodash';

                    }
                    </style>
                    <button
                    class="no-print"
                      type="button"
                      onclick="window.print()"
                    >
                      Print
                    </button>`}
                ></iframe>
              </>
            )}
          </div>
        </div>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("MANAGE STOCK - INWARD")}`}
            />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={
                  this.state.props.isEdit == 1
                    ? {
                        id: this.state.props.data.mainJangadId,
                        name: this.state.props.data.mainJangad.name,
                        // partyName: this.state.props.data.mainJangad.party.name,
                        unitName: this.state.props.data.factory.id,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        weight: this.state.props.data.weight,
                        pieces: this.state.props.data.pieces,
                        graderUserId: "",
                        remarks: this.state.props.data.nextRemarks,
                        nextRemarks: "",
                      }
                    : {
                        id: this.state.props.data.mainJangadId,
                        name: this.state.props.data.mainJangad.name,
                        // partyName: this.state.props.data.mainJangad.party.name,
                        unitName: this.state.props.data.jangad.factoryId,
                        weight: this.state.props.data.jangad.weight,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        pieces: this.state.props.data.jangad.pieces,
                        graderUserId: this.state.props.data.graderUserId,
                        remarks: this.state.props.data.remarks,
                        nextRemarks: this.state.props.data.nextRemarks,
                      }
                }
                validationSchema={Yup.object().shape({
                  id: Yup.string().required("This value is required"),
                  // partyName: Yup.string().required("This value is required"),
                  unitName: Yup.string().required("This value is required"),
                  weight: Yup.string().required("This value is required"),
                  pieces: Yup.string().required("This value is required"),
                  graderUserId: Yup.string().required("This value is required"),
                  remarks: Yup.string().max(512).nullable().notRequired(),
                  nextremarks: Yup.string().max(512).nullable().notRequired(),
                })}
                onSubmit={values => {}}
              >
                {({
                  errors,
                  status,
                  touched,
                  values,
                  submitCount,
                  validateForm,
                }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            {this.state.props.isEdit == 1 && (
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t("Add New Stock (Inward)")}
                              </h4>
                            )}
                            {this.state.props.isEdit == 2 && (
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t("Edit Stock (Inward)")}
                              </h4>
                            )}
                            {this.state.props.isEdit == 3 && (
                              <h4 className="text-black fw-bold mb-4">
                                View Stock (Inward)
                              </h4>
                            )}
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="name"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Jangad Id")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.name && touched.name
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="name"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <Label
                                  htmlFor="unitName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Unit Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.unitName && touched.unitName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="unitName"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="unitName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="category"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Diamond Category")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.category && touched.category
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="category"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="category"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="pieces"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total No of Pieces")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.pieces && touched.pieces
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={(() => {
                                      if(this.state.props.isEdit == 1){
                                        return this.state.props.data.pieces
                                      } else {
                                        return ShowDiffenence(this.state.props.data?.stockDataEntryInWards, this.state.props.data.jangad, "pieces")
                                      }

                                    })()}
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    onWheel={e => e.target.blur()}
                                    name="pieces"
                                    placeholder="2001"
                                  />
                                  <ErrorMessage
                                    name="pieces"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="weight"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total Weight")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.weight && touched.weight
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    value={(() => {
                                      if(this.state.props.isEdit == 1){
                                        return this.state.props.data.weight
                                      } else {
                                        return ShowDiffenence(this.state.props.data?.stockDataEntryInWards, this.state.props.data.jangad, "weight")
                                      }

                                    })()}
                                    type="text"
                                    onWheel={e => e.target.blur()}
                                    name="weight"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="weight"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <Label
                                  htmlFor="graderUserId"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Grader Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      `form-control ${
                                        this.state.props.isEdit == 3
                                          ? ""
                                          : "form-select"
                                      } fs-5` +
                                      (errors.graderUserId &&
                                      touched.graderUserId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.isEdit == 3
                                        ? true
                                        : false
                                    }
                                    name="graderUserId"
                                    as="select"
                                    id='gname'
                                    
                                  >
                                    <option value=""  disabled>
                                      select
                                    </option>
                                    {this.state.graderList?.map(x => (
                                      <option key={x.id}  value={x.id}>
                                        {x.name}
                                      </option>
                                    ))}
                                  </Field>
                                  <ErrorMessage
                                    name="graderUserId"
                                    id='guserid'
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                  <div id="guseriderror" className="invalid-feedback" style={{"display": "none"}}>This value is required</div>
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                      </div>

                      {this.state.props.isEdit == 3 ? (
                        ""
                      ) : (
                        <div className="row px-3 pt-3">
                          <div className="d-flex justify-content-between">
                            <h3 className="fw-bold pb-3 text-black">
                              {this.props.t("Enter stock Details")}
                            </h3>
                            <button
                              type="button"
                              className="bg-transparent border-0"
                              onClick={() => this.addRow()}
                            >
                              <img
                                src="images/dashboard-images/addRow.svg"
                                alt="add Row"
                              />
                            </button>
                          </div>
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              classes="foo"
                              headerClasses="background-light fs-5"
                              footerClasses="background-light fs-5"
                              defaultSorted={defaultSorted}
                              data={this.state.stockList}
                              columns={this.columns1}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                // nonEditableRows: () =>
                                //   this.state.notEditableRows,
                                afterSaveCell: () => {
                                  this.setState({
                                    stockList: [...this.state.stockList],
                                  });
                                },
                              })}
                            />
                            {submitCount > 0 &&
                            this.state.stockList.filter(
                              x => x.weight > 0 && x.pieces > 0
                            ).length == 0 ? (
                              <p className="text-danger">
                                Enter minimum one record
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}

                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t("Stock summary")}
                          </h3>
                        </div>

                        <div className="table-responsive" id="cloned-table">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.state.stockList}
                            columns={this.columns1}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="stockDataEntryInWards"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t("Self Internal Remarks")}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.remarks && touched.remarks
                                ? " is-invalid"
                                : "")
                            }
                            readOnly={true}
                            type="text"
                            name="remarks"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="remarks"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="nextRemarks"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t("For Next Person Remarks")}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.nextRemarks && touched.nextRemarks
                                ? " is-invalid"
                                : "")
                            }
                            disabled={
                              this.state.props.isEdit == 3 ? true : false
                            }
                            type="text"
                            name="nextRemarks"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="nextRemarks"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      {this.state.props.isEdit == 3 ? (
                        <div className="col-md-12 text-center text-md-end pe-3 py-5">
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={() => this.state.history.goBack()}
                          >
                            Back
                          </Button>
                        </div>
                      ) : (
                        <div className="col-md-12 text-center text-md-end pe-3 py-5">
                          <Button
                            color="primary"
                            className="fs-4 px-5 me-2"
                            onClick={() => {
                              this.props.history.goBack();
                            }}
                          >
                            Back
                          </Button>
                          <Button
                            color="primary"
                            id='hidesubmit'
                            className="fs-4 px-5"
                            type="submit"
                            hidden={this.state.isCreate}
                            onClick={() => {
                              this.setState({ isSubmit: true }, async () => {
                                if (this.validateTable()) {
                                  validateForm()
                                    .then(data => {
                                      if (Object.keys(data).length == 0) {
                                        this.handleSubmit(values);
                                      }
                                    })
                                    .catch(err => console.log(err));
                                }
                              });
                            }}
                          >
                            {this.state.props.isEdit == 2 ? "Update" : "Submit"}
                          </Button>
                        </div>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(DataEntryAddStockInword);
